import { useStage } from './useStage'

export default () => useStage('outbound-scheduling')
